import { render } from "./DescuentosView.vue?vue&type=template&id=0749b77a&scoped=true"
import script from "./DescuentosView.vue?vue&type=script&lang=js"
export * from "./DescuentosView.vue?vue&type=script&lang=js"

import "./DescuentosView.vue?vue&type=style&index=0&id=0749b77a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0749b77a"]])

export default __exports__